import {
	Component,
	OnInit
} from '@angular/core';
import {filter} from 'rxjs/operators';
import {
	AvlaGenericComponent,
	MessageService,
	I18nService,
} from 'shared-angular-components-avla';
import {
	AuthService,
	AvlaRestClientService
} from 'base-angular-avla';
import {
	Router,
	ActivatedRoute
} from '@angular/router';
import {CountriesService} from '../../countries.service';
import { AppConstants } from 'app/constants/app.constants';

declare var $: any;
declare var window: any;

@Component({
	selector: 'country-selection',
	templateUrl: './country-selection.component.html',
	styleUrls: ['./country-selection.component.css'],
	providers: [
		I18nService,
		CountriesService
	],
})

export class CountrySelectionComponent extends AvlaGenericComponent implements OnInit {
	constructor(
		protected restClientService: AvlaRestClientService,
		public countriesService: CountriesService,
		protected activatedRoute: ActivatedRoute,
		protected messageService: MessageService,
		protected authService: AuthService,
		protected i18n: I18nService,
		protected router: Router,
	) {
		super(restClientService, messageService, router, authService, i18n);
		this.window = window;
	}

	ngOnInit() {
		this.getCountries();
		this.selectCountryCodeByUrl();
	}

	public window;
	public countries: any[] = [];
	public disabledChangeCountry = false;

	public urlNow(url: string) {
		if (url.includes('auth/login') ) {
			return true;
		}
		return false;
	}

	public getCountries() {
		this.countriesService.findCountries().subscribe(
			(data) => {
				if (this.errorInResponse(data)) {
					return;
				}
				console.log("paises cargados");
			},
			(error) => {
				this.routeAccordingError(error);
				
			}
		);

	}

	public selectCountry(cdCountry: string) {
		if (this.countriesService.validateCountryCodeByGroup(cdCountry, this.authService.userInfoDto)) {
			setTimeout(() => {
				this.router.navigate([this.getCurrentUrl()], {queryParamsHandling: "merge", queryParams: { cdCountry: cdCountry }});
			}, 0);
		}
	}

	setLanguage(event) {
		const country = this.getLanguage(event);
		let languaje: any = {
			'key': country,
			'alt': '',
			'title': ''
		}
		this.i18n.setLanguage(languaje);
		//this.router.navigate(['home']); //Solo usar suscripción a evento languageChanged para refrescar componentes
	}

	getCurrentUrl() {
		const route = this.router.url.split('?');
		if( route.length > 0) {
			return route[0];
		} else {
			return this.router.url;
		}
	}

	public selectCountryCodeByUrl() {
		this.activatedRoute.queryParams.pipe(filter(query => query.cdCountry)).subscribe(
			(query) => {
				if (!this.authService.userInfoDto) {
					setTimeout(
						() => {
							console.log("re-consultando getCountries, esperando a authService.userInfoDto");
							this.selectCountryCodeByUrl();
						} , 300);
					return;
				} else if (
					query['cdCountry'] && 
					this.countriesService.validateCountryCodeByGroup(query['cdCountry'], this.authService.userInfoDto) &&
					query['cdCountry'] != this.countriesService.countryCodeGlobal
				) {
					setTimeout(() => {
						this.countriesService.countryCodeGlobal = query['cdCountry'];
						localStorage.setItem('countryCodeGlobal', query['cdCountry']);
					}, 0);
					 
				}					
			}
		);
		let countryCodeTemp = localStorage.getItem('countryCodeGlobal');
		if (countryCodeTemp) {
			this.setLanguage(countryCodeTemp.toLocaleLowerCase());
		}
	}


	private getLanguage(event): string {
		const countryObj = AppConstants.COUNTRIES.find(country => 
			country.value.toLocaleLowerCase() === event.toLocaleLowerCase()
		);

		const countryLanguage = countryObj ? countryObj.language.toLocaleLowerCase() : `es-${event}`;

		return countryLanguage;
	}
}
